import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  AccountingPeriod,
  AccountingPeriodStatsResponse,
} from 'src/queries/organizations/accountingPeriods/accountingPeriods.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getAccountingPeriods = async (
  organizationId: string,
): Promise<AccountingPeriod[]> =>
  getResponseData(
    axios.get<AccountingPeriod[]>(
      `/organizations/${organizationId}/accounting-periods`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getAccountingPeriodStats = async (
  organizationId: string,
  periodId: string,
): Promise<AccountingPeriodStatsResponse> =>
  getResponseData(
    axios.get<AccountingPeriodStatsResponse>(
      `/organizations/${organizationId}/accounting-periods/${periodId}/stats`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
